import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetVoucherMappingList,
	getVoucherMappingList
} from "../../redux/actions/getVoucherMappingListAction";

import {
	resetDeleteVoucherMapping,
	deleteVoucherMappingList
} from "../../redux/actions/deleteVoucherMappingAction";

import {
	resetAddNewVoucherMapping,
	addNewVoucherMappingList
} from "../../redux/actions/addNewVoucherMappingAction";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const VoucherMapping = () => {
	const classes = useStyles();
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [currency, setcurrency] = useState("");
	const [deleteBtnName, setdeleteBtnName] = useState("");
	const [voucherRates, setvoucherRates] = useState("");
	const [voucherMappingId, setvoucherMappingId] = useState("");
	const [voucherMappingCurrency, setvoucherMappingCurrency] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [page, setPage] = useState(0);
	const [getVoucherMappingListStatus, setGetVoucherMappingListStatus] =
		useState(false);

	const [getVoucherMappingListArray, setgetVoucherMappingListArray] = useState(
		[]
	);

	const [addVoucherMappingListArray, setaddVoucherMappingListArray] =
		useState("");

	const [addNewVoucherMappingStatus, setaddNewVoucherMappingStatus] =
		useState(false);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const createPerson = () => {
		if (voucherRates == "") {
			return false;
		}

		setaddNewVoucherMappingStatus(true);
		setvoucherMappingId(voucherRates);
		const addNewVoucherMappingReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency,
				voucherRates: voucherRates
			}
		};

		return dispatch(
			addNewVoucherMappingList(addNewVoucherMappingReq, authToken)
		);

		// setgetVoucherMappingListArray([
		//   ...getVoucherMappingListArray,
		//   {
		//     id: getVoucherMappingListArray.length + 1,
		//     currency: "6",
		//     voucherRates: "7",
		//   },
		// ]);
	};

	const addNewVoucherMappingRes = useSelector(
		({ addNewVoucherMapping }) => addNewVoucherMapping
	);

	useEffect(() => {
		if (addNewVoucherMappingStatus) {
			getVoucherMappingListApi();
			if (addNewVoucherMappingRes.data.status == "success") {
				setgetVoucherMappingListArray([
					...getVoucherMappingListArray,
					{
						id: getVoucherMappingListArray.length + 1,
						currency: currency,
						voucherRates: voucherRates,
						voucherMappingId: voucherMappingId
					}
				]);
			}
			if (addNewVoucherMappingRes.data.status == "failed") {
				setNotificationOpen(true);
				setaddVoucherMappingListArray(addNewVoucherMappingRes.data);
				if (
					addNewVoucherMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewVoucherMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addNewVoucherMappingRes.data.status == "Failed") {
				setNotificationOpen(true);
				setaddVoucherMappingListArray(addNewVoucherMappingRes.data);
				if (
					addNewVoucherMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewVoucherMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [addNewVoucherMappingRes.data.status]);

	//delete
	const [deleteVoucherMappingStatus, setdeleteVoucherMappingStatus] =
		useState(false);

	const [deleteVoucherMappingArray, setdeleteVoucherMappingArray] =
		useState("");

	const [users, setUsers] = useState(getVoucherMappingListArray);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);
	// console.log("adminCurrencyList", adminCurrencyList);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			// setcurrency(value);
			setcurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "voucherRates") {
			// setvoucherRates(value);
			Util.verifyNumber(value)
				? setvoucherRates(value)
				: setvoucherRates(voucherRates);
		}
	};

	const getVoucherMappingListApi = () => {
		setIsLoading(true);
		// if (currency) {
		setGetVoucherMappingListStatus(true);
		const getVoucherMappingListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency
			}
		};

		return dispatch(getVoucherMappingList(getVoucherMappingListReq, authToken));
		// }
		//  else {
		//   setIsLoading(false);
		//   setGetVoucherMappingListStatus(false);
		// }
	};

	const getVoucherMappingListRes = useSelector(
		({ getVoucherMappingList }) => getVoucherMappingList
	);

	useEffect(() => {
		if (getVoucherMappingListStatus) {
			if (getVoucherMappingListRes.data.status == "success") {
				setIsLoading(false);
				setPage(0);
				setgetVoucherMappingListArray(
					[].concat(getVoucherMappingListRes.data.customerDetailsVOList)
				);

				// setvoucherMappingCurrency(
				// 	getVoucherMappingListRes.data.customerDetailsVOList[0].currency
				// );
			}
			if (getVoucherMappingListRes.data.status == "Failed") {
				setIsLoading(false);
				setgetVoucherMappingListArray(getVoucherMappingListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherMappingListRes.data.description
				);
				if (
					getVoucherMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherMappingListRes.data.status == "failed") {
				setIsLoading(false);
				setgetVoucherMappingListArray(getVoucherMappingListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherMappingListRes.data.status
				);
				if (
					getVoucherMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherMappingListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetVoucherMappingListArray([])
				// setgetVoucherMappingListArray(getVoucherMappingListRes.data);
				// NotificationPopups(
				// 	"error",
				// 	"Failed",
				// 	getVoucherMappingListRes.data.status
				// );
			}
		}
	}, [getVoucherMappingListRes.data.status]);

	// useEffect(() => {
	//   if (getVoucherMappingListRes.data.status == "success") {
	//     setPage(0);
	//   }
	// }, [getVoucherMappingListRes.data.status]);

	const handleRemoveItem = (voucherMappingId) => {
		// const name = e.target.getAttribute("name");
		// setdeleteBtnName(name);
		setdeleteVoucherMappingStatus(true);
		const getVoucherMappingListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				// voucherMappingId: e.target.getAttribute("name"),
				voucherMappingId: voucherMappingId
			}
		};

		return dispatch(
			deleteVoucherMappingList(getVoucherMappingListReq, authToken)
		);

		// const name = e.target.getAttribute("name");
		// setgetVoucherMappingListArray(
		//   getVoucherMappingListArray.filter(
		//     (item) => item.voucherMappingId !== name
		//   )
		// );
	};

	const deleteVoucherMappingRes = useSelector(
		({ deleteVoucherMapping }) => deleteVoucherMapping
	);

	useEffect(() => {
		if (deleteVoucherMappingStatus) {
			if (deleteVoucherMappingRes.data.status == "success") {
				setgetVoucherMappingListArray(
					getVoucherMappingListArray.filter(
						(item) => item.voucherMappingId !== deleteBtnName
					)
				);
				getVoucherMappingListApi();
			}
		}
	}, [deleteVoucherMappingRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<TextField
								select
								required
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								placeholder="Please Select Currency"
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>

						<Grid item sm={12} md={6} lg={6} container>
							<Grid>
								{/* <Button
                  style={{
                    backgroundColor: "#00b9f5",
                    color: "white",
                    marginTop: "7px",
                  }}
                  endIcon={<AiOutlineSearch />}
                  variant="contained"
                  onClick={getVoucherMappingListApi}
                >
                  Search
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getVoucherMappingListApi}
								>
									Search <SearchIcon />
								</CustomButton>
							</Grid>
							<Grid item md={7}></Grid>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getVoucherMappingListArray.length == undefined ||
					!getVoucherMappingListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Voucher Mapping
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Voucher Mapping
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rates
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getVoucherMappingListArray &&
											[]
												.concat(getVoucherMappingListArray)
												.map((row, index) => (
													<TableRow key={row.walletId}>
														<TableCell align="center">{row.currency}</TableCell>
														<TableCell align="center">
															{row.voucherRates}
														</TableCell>
														<TableCell align="center">
															<Tooltip title="Delete">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	name={row.voucherMappingId}
																	//  onClick={handleRemoveItem}
																	onClick={() =>
																		handleRemoveItem(row.voucherMappingId)
																	}
																>
																	{/* Delete */}
																	{
																		<DeleteIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}

										<TableRow>
											<TableCell align="center">
												{/* {voucherMappingCurrency} */}
												{currency}
											</TableCell>

											<TableCell align="center">
												<TextField
													size="small"
													color="primary"
													autoFocus={true}
													variant="standard"
													type="text"
													label="Rates"
													fullWidth={true}
													name="voucherRates"
													value={voucherRates || ""}
													onChange={handleChange}
												/>
											</TableCell>

											<TableCell align="center">
												<CustomButton
													style={{
														padding: "8px"
													}}
													// onClick={addRow}
													onClick={createPerson}
												>
													{/* Add */}
													{
														<AddCircleOutlineIcon
															style={{
																color: "#fff",
																fontSize: "20px"
															}}
														/>
													}
												</CustomButton>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
			{addVoucherMappingListArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addVoucherMappingListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addVoucherMappingListArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addVoucherMappingListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addVoucherMappingListArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addVoucherMappingListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default VoucherMapping;
